<!--
 * @Author: Merlin
 * @Date: 2024-03-25 19:09:00
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-27 17:05:51
 * @Description: 这是 pro 模式的3个输入框  
-->
<template>
    <div class="blackjack-pro-input-group">
        <InputBoxAmount
            icon
            class=""
            mode="multiple"
            inputmode="decimal"
            :label="tt.GameBlackJack.PerfectPairs"
            v-model="pairsAmount"
            :disabled="disabled"
            :min="0"
            :max="oJoinStateStore?.betttingLimits?.maxBets"
        />
        <InputBoxAmount
            icon
            class=""
            mode="multiple"
            inputmode="decimal"
            :label="'21 + 3'"
            v-model="tripleAmount"
            :disabled="disabled"
            :min="0"
            :max="oJoinStateStore?.betttingLimits?.maxBets"
        />
    </div>
</template>

<script lang="ts">
import betHelper from '~/common/js/betHelper';
import useTranslation from '~/i18n/useTransLation';
import { useJoinStateStore } from '~/stores/cansino/joinState';
const isDev = import.meta.dev;

export default defineComponent({
    name: 'GameControls',
    props: {
        disabled: {
            type: Boolean,
            default: false, 
        },
        oForm: {
            type: Object,
            required: true,
        },
    },
    data() {
        const oBetInfo = {
            pairsAmount: '0', 
            tripleAmount: '0', 
        };
        if (isDev){
            oBetInfo.pairsAmount = oBetInfo.tripleAmount = '1';
        }
        return {
            oJoinStateStore: useJoinStateStore(),
            tt: useTranslation(),
            ...oBetInfo,
            gameLoaded: '', 
        };
    },
    watch: {
        // ↓ 加载未完成的游戏 
        'oJoinStateStore.lastRound': {
            deep: true,
            immediate: true,
            async handler(oRound) {
                if (import.meta.server || !oRound?.hash) return; 
                if (this.gameLoaded == oRound.hash) return; 
                // console.log('进行中的游戏：', deepCopy(oRound)); 
                this.gameLoaded = oRound.hash; 
                this.pairsAmount = oRound.tripleBetAmount || 0;
                this.tripleAmount = oRound.tripleBetAmount || 0; 
            },
        },
    },
    methods: {

    },
    computed: {

    },
});
</script>


<style scoped lang="scss">
@import '~/common/style/game.module.scss';

.blackjack-pro-input-group{
    display: flex;
    --gap-value: 8px;
    gap: var(--gap-value);
    .disabled{
        opacity: 0.8; // 覆盖 0.6 
    }
    .input-outer{
        flex: 1 1 50%;
    }
    :deep(.input-body){
        background-color: #161F2C;
    }
}

</style>

